<template>
  <div class="blank">
    <h1>404 页面不存在</h1>
    <p>您访问的页面不存在，请返回 <router-link to="/home">首页</router-link></p>
  </div>
</template>
  
<script>
export default {
  name: "NotFound",
};
</script>

<style lang="less">
.blank {
  text-align: center;
  margin-top: 150px;
}
</style>